import { render } from "./viewEdit.vue?vue&type=template&id=ab8aa2ba&scoped=true&ts=true"
import script from "./viewEdit.vue?vue&type=script&lang=ts"
export * from "./viewEdit.vue?vue&type=script&lang=ts"

import "./viewEdit.vue?vue&type=style&index=0&id=ab8aa2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab8aa2ba"]])

export default __exports__